// copied from old grid.js
import React, { forwardRef } from "react";
import { Box } from "@indeed/ifl-components";
import { filterUndefined, mapResponsive } from "helpers/utils";

/**
 * An adaptation from Chakra UI
 * https://github.com/chakra-ui/chakra-ui/blob/main/packages/layout/src/grid.tsx
 */

export const Grid = forwardRef(
  (
    {
      area,
      templateAreas,
      gap,
      rowGap,
      columnGap,
      column,
      row,
      autoFlow,
      autoRows,
      templateRows,
      autoColumns,
      templateColumns,
      sx,
      ...props
    },
    ref
  ) => {
    const styles = {
      display: "grid",
      gridArea: area,
      gridTemplateAreas: templateAreas,
      gridGap: gap,
      gridRowGap: rowGap,
      gridColumnGap: columnGap,
      gridAutoColumns: autoColumns,
      gridColumn: column,
      gridRow: row,
      gridAutoFlow: autoFlow,
      gridAutoRows: autoRows,
      gridTemplateRows: templateRows,
      gridTemplateColumns: templateColumns,
      ...sx,
    };

    return <Box ref={ref} sx={styles} {...props} />;
  }
);

const spanFn = (span) =>
  mapResponsive(span, (value) =>
    value === "auto" ? "auto" : `span ${value}/span ${value}`
  );

export const GridItem = forwardRef(
  (
    { colSpan, colStart, colEnd, rowEnd, rowSpan, rowStart, sx, ...props },
    ref
  ) => {
    const styles = filterUndefined({
      gridColumn: spanFn(colSpan),
      gridRow: spanFn(rowSpan),
      gridColumnStart: colStart,
      gridColumnEnd: colEnd,
      gridRowStart: rowStart,
      gridRowEnd: rowEnd,
      ...sx,
    });

    return <Box ref={ref} sx={styles} {...props} />;
  }
);
